import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

function SwitchLabels({
  id,
  label,
  hasError,
  helpText,
  size,
  checked,
  onChange,
  name,
  value,
  hint,
  disabled = false,
  labelPlacement = 'end',
  innerRef,
  ...other
}) {
  const component = (
    <Switch
      color="primary"
      name={name}
      disabled={disabled}
      size={size}
      checked={checked}
      onChange={onChange}
      value={value}
    />
  );
  return (
    <FormControl
      ref={innerRef}
      margin="normal"
      error={hasError}
      sx={{
        '&.MuiFormControl-fullWidth .MuiFormControlLabel-label': {
          flex: 1,
        },
      }}
      {...other}
    >
      <FormGroup>
        {label ? (
          <FormControlLabel
            sx={{ ml: 0.5 }}
            control={component}
            label={label}
            labelPlacement={labelPlacement}
          />
        ) : (
          component
        )}
        {hint && (
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ ml: '52px' }}
          >
            {hint}
          </Typography>
        )}
        {hasError && <FormHelperText>{helpText}</FormHelperText>}
      </FormGroup>
    </FormControl>
  );
}

SwitchLabels.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  hasError: PropTypes.bool,
  helpText: PropTypes.string,
  hint: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium']),
  labelPlacement: PropTypes.oneOf(['start', 'end']),
  disabled: PropTypes.bool,
  innerRef: PropTypes.any,
};

export default SwitchLabels;

export const Checkbox = React.forwardRef((props, ref) => (
  <SwitchLabels {...props} innerRef={ref} />
));
